if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      };

      const languageButtons = this.querySelectorAll('[data-type="language"]');

      languageButtons.forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      );

      this.determineActiveLanguage(languageButtons);
    }

    onItemClick(event) {
      event.preventDefault();
      window.location.href = event.currentTarget.dataset.url;
    }

    determineActiveLanguage(languageButtons) {
      const currentUrlWithLanguageCountryRoute =
        window.location.origin + window.Shopify.routes.root;

      languageButtons.forEach((item) => {
        if (currentUrlWithLanguageCountryRoute === item.dataset.url) {
          item.closest('li').dataset.activeLanguage = true;

          item.ariaCurrent = true;
        }
      });
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
